import type { UserType } from 'graphql-ts-types';

import { CheckboxValue } from 'common/enums/form';
import { FieldName } from '../enums';

export type FormData = {
  [key in FieldName]: string;
};

export interface RegistrationFormFields {
  company: string;
  vatNumber: string;
  gender: string;
  firstname: string;
  lastname: string;
  email: string;
  newsletterSubscription: boolean;
  password?: string;
  homeClubSubscription?: boolean;
  userType: UserType;
}

interface InitialFormData {
  userType: UserType;
  firstName: string;
  lastName: string;
  email?: string;
}

export const getRegistrationFormFields = (
  formData: FormData,
  isThirdPartySignUpFlow: boolean
): RegistrationFormFields => ({
  userType: formData[FieldName.UserType] as UserType,
  company: formData[FieldName.Company],
  vatNumber: formData[FieldName.VatNumber],
  gender: formData[FieldName.Title],
  firstname: formData[FieldName.FirstName],
  lastname: formData[FieldName.LastName],
  email: formData[FieldName.EmailAddress],
  ...(!isThirdPartySignUpFlow && {
    password: formData[FieldName.Password],
  }),
  newsletterSubscription: formData[FieldName.NewsletterSubscription] === CheckboxValue.True,
  homeClubSubscription: formData[FieldName.HomeClubSubscription] === CheckboxValue.True,
});

export const getInitialFormData = ({ firstName, lastName, email, userType }: InitialFormData) =>
  new Map<FieldName, string>([
    [FieldName.FirstName, firstName],
    [FieldName.LastName, lastName],
    [FieldName.EmailAddress, email],
    [FieldName.UserType, userType],
  ]);

export const removeWhiteSpaces = (value: string) => value.replace(/\s/g, '');
